var $ = require('jquery');
var _ = require('underscore');
var messageMyTeamTemplate = require('./message-my-team-dialog.hbs');
var usersTemplate = require('./message-my-team-users.hbs');
var groupsTemplate =  require('./message-my-team-groups.hbs');
var notification = require('../deprecated/ui/notification');
var toggle = require('../deprecated/ui/dialog/toggle');
var SwapList = require('../deprecated/widget/swap-list');
var messageFileUploader = require('./message-fileuploader');
var pluralize = require('../plugins/hbs/helpers/pluralize');
var data = require('hudl-base').data;
var utils = require('hudl-base')._;
var ajax = require('hudl-base').Xhr;

require('../lib/jquery.watermark');
require('../ui/jquery.charlimit');

var messageMyTeamEnabled = data.getNullable('hasMessageTeam'),
    // TODO lyleshearer 10/28/2013 - if message my team is reworked, this should be lazy-loaded (in combination with the user/group info and anything else necessary to build the dialog)
    messagingData = utils.copyObjectToPascalCase(data.getNullable('messaging'));

function formatCount(count, label) {
    return (count > 0) ? pluralize(count + ' ' + label, count) : '';
}

var Message = {

    Loaded: false,
    SwapList: null,
    fileUploader: null,
    recipients: null,
    defaultRecipients: [],
    defaultSubject: '',
    defaultMessage: '',

    chooseTeam: function (teamID, permission) {
        Message.clearFilter();
        Message.showDeliveryOptions(teamID, permission);
        Message.loadUsersGroupsData(teamID, Message.buildRecipientList);
        Message.showAttachmentArea(teamID);
        Message.TeamID = teamID;
    },

    clearFilter: function () {
        var ugFilter = $('#ugFilter').get(0);
        if ($.isFunction(ugFilter.clear)) {
            ugFilter.clear();
        }
    },

    showDeliveryOptions: function (teamId, permission) {
        var _setDeliveryOptions = function (hasTextFeature) {
            if (hasTextFeature === "true") {
                $('#label-send-text').show();
            } else {
                $('#label-send-text').hide();
                $('#send-text').prop('checked', false);
            }
        };

        if (!permission) {
            // if value is not present in DOM, fetch from server
            ajax.instance.post('/message/doesTeamHaveTextMessagingEnabled', { teamId: teamId }).done(function (hasTextFeature) {
                // cache permission value in DOM
                var selectedTeam = $('#teamMenu li[data-teamId=' + teamId + ']');
                selectedTeam.attr('data-has-text', hasTextFeature);
                // server returns a Boolean, which will cause problems in _setDeliveryOptions
                // once it is stored in DOM, it is always retrieved as a String.
                _setDeliveryOptions(hasTextFeature.toString());
            });
        } else {
            _setDeliveryOptions(permission);
        }
    },

    loadUsersGroupsData: function (teamID, loadList) {
        var context = this;

        $('#userGroupsLoading').show();
        ajax.instance.post('/message/getusersandgroups', {
            teamId: teamID
        }).done(function (ug) {
            Message.recipients = ug;
            $('#userGroupsLoading').hide();
            loadList(teamID, context);
        });

    },

    buildRecipientList: function (teamID, context) {
        var ug = context.recipients;
        var available = $('#availableUG');
        if (Message.SwapList) {
            Message.SwapList.reset();
            $('ul.sl').html('');
        } else {
            Message.SwapList = new SwapList($('#ugFilter').get(0), available.get(0), $('#includedUG').get(0));
        }

        available.append(groupsTemplate(ug.Groups));
        available.append(usersTemplate(ug.Users));

        var selectedTeam = $('#teamMenu li[data-teamID=' + teamID + ']');
        if (selectedTeam) {
            $('#msg-share-with').html(selectedTeam.html());
        }

        Message.SwapList.InitDragDrop();

        if (Message.defaultRecipients.length) {
            _.each(Message.defaultRecipients, function (defaultRecipient) {
                var item = available.find('[groupid="' + defaultRecipient + '"]');
                if (!item.length) {
                    item = available.find('[userid="' + defaultRecipient + '"]');
                }

                if (item.length) {
                    Message.SwapList.SelectItem(item);
                    Message.SwapList.Move(Message.SwapList.List1, Message.SwapList.List2);
                }
            }, this);
        }

        setTimeout(function () {
            ajax.instance.post('/message/UpdateLastTeam', {
                teamId: teamID
            });
        }, 250);

    },

    showAttachmentArea: $.proxy(function (teamId) {
        // hac - iOS devices should not have the option to upload attachments
        var iOS = !!navigator.userAgent.match('iPhone OS') || !!navigator.userAgent.match('iPad');
        if (teamId && teamId > 0 && !iOS) {
            // hac - are attachments enabled for this team?
            ajax.instance.post('/message/doesTeamHaveAttachmentsEnabled', {
                teamId: teamId
            }).done(function (hasAttachments) {
                if (hasAttachments) {
                    $('#attachments-row').show();
                } else {
                    $('#attachments-row').hide();
                }
            });
        } else {
            $('#attachments-row').hide();
        }
    }, this),

    showDialogClick: $.proxy(function (e, hideTxt, _defaultRecipients, _defaultSubject, _defaultMessage) {
        e.stopPropagation();
        e.preventDefault();

        var selectedTeam;
        $(document).click(closeDropMenu);

        var teamID = Message.TeamID;

        Message.defaultRecipients = _defaultRecipients || [];
        Message.defaultSubject = _defaultSubject || '';
        Message.defaultMessage = _defaultMessage || '';

        if (teamID && teamID > 0) {
            selectedTeam = $('#teamMenu').find('li[data-teamID="' + teamID + '"]');
            Message.chooseTeam(teamID, selectedTeam.attr('data-permission'));
        } else {
            ajax.instance.post('/message/getlastteam').done(function (teamID) {
                if (!Message.TeamID && teamID > 0) {
                    selectedTeam = $('#teamMenu').find('li[data-teamID="' + teamID + '"]');
                    Message.chooseTeam(teamID, selectedTeam.attr('data-permission'));
                } else {
                    selectedTeam = $('#teamMenu').find('li:first');
                    if (selectedTeam) {
                        Message.chooseTeam(selectedTeam.attr('data-teamid'), selectedTeam.attr('data-permission'));
                    }
                }
            });
        }

        // hac - init uploader
        Message.fileUploader = new messageFileUploader.FileUploader({
            debug: false,
            element: $('#uploads')[0],
            multiple: true,
            sizeLimit: 20971520,
            maxConnections: 5,
            action: '/message/uploadfile'
        });

        $(document).bind('uploaderError', function (e, arg) {
            notification.set(arg.message, {
                type: 'error'
            });
        });

        // hac - reset the checkboxes
        $('#send-email').removeAttr('disabled');
        $('#send-email').prop('checked', true);
        $('#send-text').prop('checked', false);

        // hac - if there are attachments available, the user must "send email"
        $(document).bind('uploaderAttachmentCountChanged', function (e, arg) {
            if (arg.hasAttachments) {
                $('#send-email').prop('checked', true);
                $('#send-email').attr('disabled', 'disabled');
            } else {
                $('#send-email').removeAttr('disabled');
            }
        });

        $('#msg-body').val(Message.defaultMessage);
        $('#msg-limiter').text('');
        $('#msg-subject').val(Message.defaultSubject);
        $('#ugFilter').val('');

        if (hideTxt) {
            $('#send-both').prop('disabled', true).parent().addClass('disabled');
            $('#send-email').prop('checked', true);
        } else {
            $('#send-both').prop({
                'checked': true,
                'disabled': false
            }).parent().removeClass('disabled');
        }

        if (Message && Message.SwapList) {
            // sends the 'Backspace' key to reset the filter box
            // tyson.stewart 19 December 2011 - Have to defer this because IE is awful.
            _.defer(function () {
                Message.SwapList.FilterKeyPressed({
                    which: 8
                });
            });
        }

        if (this.limiter) {
            this.limiter.HideRemainingText();
        }

        if (!Message.Loaded) {
            Message.Loaded = true;

            $('#ugFilter').watermark('Search roster & groups');
            // Changed from 400 because of new SMS subject formatting. It looks significantly cleaner at the low cost of 11 characters total.
            $('#msg-body').charlimit(389, {
                status: '#msg-limiter',
                startAt: 100,
                format: '{0} characters remaining'
            });

            $('#send-team-message').click(Message.sendMessageClick);

            $('#teamMenu .teams li').click(function () {
                Message.chooseTeam($(this).attr('data-teamID'), $(this).attr('data-permission'));
            });
        }

        var sendMessageDiv = $('#sendmsg');
        toggle.toggle(sendMessageDiv.get(0));
        var sendMessageContainer = sendMessageDiv.parent();
        sendMessageContainer.css({
            'overflow': 'visible',
            'background-color': 'transparent',
            'transform': 'scale(1)'
        });

        $('#ugFilter').focus();

        return false;
    }, this),

    sendMessageClick: function (e) {
        e.stopPropagation();

        // hac - do not send the message if any uploads are in progress
        if (Message.fileUploader._filesInProgress > 0) {
            notification.set('There are uploads in progress, please wait for them to complete before sending the message.', {
                type: 'error'
            });
            return;
        }

        // hac - do not send the message if the user has not picked at least one delivery method
        if (!($('#send-email').is(':checked') || $('#send-text').is(':checked'))) {
            notification.set('You must select at least one method of delivery. Send Email, or Send Text.', {
                type: 'error'
            });
            return;
        }

        var users = [],
            groups = [];
        $('#includedUG li').each(function () {
            if ($(this).attr('isgroup') === 'true') {
                groups.push($(this).attr('groupid'));
            } else {
                users.push($(this).attr('userid'));
            }
        });
        if (users.length === 0 && groups.length === 0) {
            notification.set('You must choose some users and/or groups first', {
                type: 'error'
            });
            return;
        }
        var subject = $('#msg-subject').val(),
            body = $('#msg-body').val();
        if (!subject && !body) {
            notification.set('You must enter a subject and/or body for your message', {
                type: 'error'
            });
            return;
        }

        var throbber = $('#msg-throbber').show();

        $(this).prop('disabled', true).val('Sending...');

        var finish = $.proxy(function () {
            $(this).prop('disabled', false).val('Send Message');
            throbber.hide();
        }, this);

        ajax.instance.post('/message/sendmessage', {
            teamId: Message.TeamID,
            userIds: users,
            groupIds: groups,
            subject: subject,
            message: body,
            sendEmail: $('#send-email').is(':checked'),
            sendText: $('#send-text').is(':checked'),
            attachments: Message.fileUploader._completedFiles
        })
            .done(function (counts) {
                finish();
                var sentMessage = 'Sent ' + formatCount(counts.messagesSent, 'email message') + (counts.messagesSent > 0 && counts.txtMessagesSent > 0 ? ' and ' : '') + formatCount(counts.txtMessagesSent, 'text message');
                notification.set(sentMessage + ' <a href="http://www.hudl.com/tutorials/message-my-team">Learn more</a>.');
                toggle.toggle('#sendmsg');
            }).fail(function () {
                notification.set('The message could not be sent, please try again later', {
                    type: 'error'
                });
                finish();
            });
    },

    init: _.once(function () {
        if (!messageMyTeamEnabled) {
            return;
        }

        // message my team is enabled, ensure the data is included
        if (!messagingData) {
            throw 'Messaging data not defined.';
        }

        $(function () {
            // TODO extract this to a smooth modal module
            var smoothModal = $('.smooth-modal');
            if (!smoothModal.length) {
                var modalOverlay = $('<div class="smooth-modal-overlay"><div class="smooth-modal" /></div>').prependTo('body');
                smoothModal = modalOverlay.find('.smooth-modal');
            }

            var dialog = $(messageMyTeamTemplate(messagingData)).appendTo(smoothModal);

            dialog.find('.buttons')
                .on('click', '.all-right', function () {
                    Message.SwapList.MoveAll(Message.SwapList.List1, Message.SwapList.List2);
                })
                .on('click', '.one-right', function () {
                    Message.SwapList.Move(Message.SwapList.List1, Message.SwapList.List2);
                })
                .on('click', '.one-left', function () {
                    Message.SwapList.Move(Message.SwapList.List2, Message.SwapList.List1);
                })
                .on('click', '.all-left', function () {
                    Message.SwapList.MoveAll(Message.SwapList.List2, Message.SwapList.List1);
                });

            $('#message-link').click(Message.showDialogClick);

            $('#sendmsg').find('> a.dlg_close, > div.footer > a')
                .click(function (e) {
                    e.preventDefault();
                    toggle.toggle($(this).closest('.modalPopup').get(0));
                    e.stopPropagation();
                    return false;
                });

            $('#teamChooser').click(function (event) {
                var menu = $('#teamMenu');
                if (menu.is(':visible')) {
                    closeDropMenu();
                } else {
                    var dropFromElement = $(this);
                    if (dropFromElement.length) {
                        var pos = dropFromElement.position();
                        menu.css({
                            'position': 'absolute',
                            'top': pos.top + dropFromElement.innerHeight(),
                            'left': pos.left
                        }).show();
                    }
                }
                event.stopPropagation();
            });

            $('#teamMenu > ul').click(function (event) {
                var display = $('#teamChooser .display:first');
                var item = $(event.target);
                display.html(item.html());
                item.addClass('selected').siblings().removeClass('selected');
            });
        });
    })
};

function closeDropMenu(e) {
    // do not hide the menu when clicking a link in the notification area
    if (e) {
        var elem = $(e.target);
        if (elem.is('a') && elem.closest('#notificationinner').length) {
            return;
        }
    }

    var menu = $('.dropDown');
    if (menu.is(':visible')) {
        menu.slideUp(250);
    }
}

module.exports = Message;
